import type { FC } from 'react';
import { ToggleGroup } from '@interstate/components/ToggleGroup';

import { FIRST_PENCIL_PROGRAM_TABS } from './utils';
import type { FirstPencilProgramsOfferType } from './types';

type FirstPencilOfferTypeToggleProps = {
    value: FirstPencilProgramsOfferType;
    onChange: (offerType: FirstPencilProgramsOfferType) => void;
};

export const FirstPencilOfferTypeToggle: FC<FirstPencilOfferTypeToggleProps> = ({ value, onChange }) => (
    <ToggleGroup
        size="sm"
        toggleWidth="100%"
        data-testid="first-pencil-offer-type-toggle"
        onChange={(_event: unknown, next: FirstPencilProgramsOfferType) => {
            if (next && next !== value) {
                onChange(next);
            }
        }}
        toggleButtonOptions={FIRST_PENCIL_PROGRAM_TABS.map((tab) => ({
            selected: tab.value === value,
            value: tab.value,
            children: tab.label,
            'aria-label': tab.label,
            'data-testid': `first-pencil-offer-type-${tab.value}`
        }))}
    />
);
